module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(_vm.up) ? _c('div', {
    staticClass: "del-block m-t-5"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._m(1), _vm._v(" "), _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.addStoresSetting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.addStoresSetting.choose),
      callback: function($$v) {
        _vm.$set(_vm.addStoresSetting, "choose", $$v)
      },
      expression: "addStoresSetting.choose"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(this.addStoresSetting.choose.length) + " 間")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            取消\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            確定\n          ")]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-20 text-center",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('h3', [_vm._v("複製此分店所有設定至其他店家")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a39b65b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/CopyScheduleProdTemp.vue
// module id = 2344
// module chunks = 1